import { combineEpics } from 'redux-observable';
import { fetchAllContractsEpic } from './fetch-all-contracts.epic';
import { fetchSelectedContractByIdEpic } from './fetch-selected-contract-by-id.epic';

export const combinedContractsEpics = combineEpics(
    fetchAllContractsEpic,
    fetchSelectedContractByIdEpic,
);
